export const MODULES = [
  { id: 'feeding',       name: 'Feeding',        icon: 'Utensils',  color: 'amber',   desc: 'Daily meal cost tracking, payment recording, and reports with automatic charge calculation based on attendance.', features: ['Daily attendance-linked charges', 'Auto-recalculation on absence', 'Payment history & ledger', 'Term reports', 'Holiday & weekend exclusions'] },
  { id: 'attendance',    name: 'Attendance',      icon: 'Calendar',  color: 'cyan',    desc: 'Absentee marking with weekly locking and admin override capability.', features: ['Daily absentee entry', 'Attendance history log', 'Weekly lock (Mon 7PM)', 'Admin unlock overrides', 'Class-level summaries'] },
  { id: 'academics',     name: 'Academics',       icon: 'GraduationCap',  color: 'indigo',  desc: 'Classes, subjects, academic terms, assessments, grades, timetables, homework, and report cards.', features: ['Classes & sections', 'Subject management', 'Academic terms', 'Assessments & grading', 'Report cards', 'Timetable', 'Homework tracking'] },
  { id: 'finance',       name: 'Finance',         icon: 'DollarSign',  color: 'emerald', desc: 'Fee plans, invoicing, and payment tracking for school finances.', features: ['Fee plans', 'Invoice generation', 'Payment tracking', 'Financial reports', 'Outstanding balances'] },
  { id: 'transport',     name: 'Transport',       icon: 'Bus',  color: 'blue',    desc: 'Bus route management, student assignments, outage tracking, and transport payment logs.', features: ['Route management', 'Student assignments', 'Outage tracking', 'Transport payment log', 'Route reports'] },
  { id: 'hostel',        name: 'Hostel',          icon: 'Home',  color: 'slate',   desc: 'Dormitory room management and student room assignments for boarding schools.', features: ['Room catalog', 'Student allocations', 'Capacity tracking', 'Occupancy reports'] },
  { id: 'library',       name: 'Library',         icon: 'BookOpen',  color: 'rose',    desc: 'Book catalog management and loan tracking.', features: ['Book catalog', 'Loan tracking', 'Return processing', 'Availability status'] },
  { id: 'admissions',    name: 'Admissions',      icon: 'ClipboardList',  color: 'orange',  desc: 'Application pipeline management and conversion of applicants to enrolled students.', features: ['Application intake', 'Status tracking', 'Student enrollment', 'Admissions reports'] },
  { id: 'inventory',     name: 'Inventory',       icon: 'Package',  color: 'teal',    desc: 'Asset and supply tracking with categories and quantities.', features: ['Item catalog', 'Category management', 'Quantity tracking', 'Inventory reports'] },
  { id: 'parents',       name: 'Parents',         icon: 'Users',  color: 'pink',    desc: 'Parent account management with self-service portal for viewing student information and announcements.', features: ['Parent accounts', 'Multi-child linking', 'Self-service portal', 'View announcements', 'View payments'] },
  { id: 'communications',name: 'Communications',  icon: 'MessageSquare',  color: 'sky',     desc: 'SMS broadcasts and announcements to parents with credit-based system.', features: ['SMS broadcast', 'Announcements', 'Credit-based system', 'Queue & retry', 'Delivery monitoring'] },
]

export const ROLES = [
  { name: 'Admin',           desc: 'Full platform access, settings, users, SMS credits, audit logs' },
  { name: 'Headteacher',     desc: 'Attendance, students, reports, announcements' },
  { name: 'Accountant',      desc: 'Payments, fee plans, invoices, revenue reports' },
  { name: 'Class Teacher',   desc: 'Attendance, grades, homework, report cards' },
  { name: 'Admissions',      desc: 'Application pipeline, student enrollment' },
  { name: 'Librarian',       desc: 'Book catalog and loan management' },
  { name: 'Transport',       desc: 'Routes, assignments, outages, payment logs' },
  { name: 'Hostel',          desc: 'Rooms and student allocations' },
  { name: 'Inventory',       desc: 'Asset and supply tracking' },
  { name: 'Feeding Manager', desc: 'Feeding payments, student ledger, reports' },
  { name: 'Parent',          desc: 'Self-service: view children, announcements' },
]

export const MOCK_STUDENTS = [
  { id: 1,  name: 'Abena Mensah',     class: 'Grade 7A', balance: 120,    status: 'paid',    avatar: 'AM' },
  { id: 2,  name: 'Kwame Asante',     class: 'Grade 8B', balance: 0,      status: 'owing',   avatar: 'KA' },
  { id: 3,  name: 'Efua Darko',       class: 'Grade 6A', balance: 450,    status: 'paid',    avatar: 'ED' },
  { id: 4,  name: 'Kofi Boateng',     class: 'Grade 7B', balance: 0,      status: 'current', avatar: 'KB' },
  { id: 5,  name: 'Ama Sarpong',      class: 'Grade 9A', balance: 780,    status: 'paid',    avatar: 'AS' },
  { id: 6,  name: 'Yaw Owusu',        class: 'Grade 8A', balance: 200,    status: 'owing',   avatar: 'YO' },
  { id: 7,  name: 'Akosua Frimpong',  class: 'Grade 6B', balance: 90,     status: 'paid',    avatar: 'AF' },
  { id: 8,  name: 'Nana Acheampong',  class: 'Grade 9B', balance: 0,      status: 'owing',   avatar: 'NA' },
  { id: 9,  name: 'Adwoa Kusi',       class: 'Grade 7A', balance: 330,    status: 'paid',    avatar: 'AK' },
  { id: 10, name: 'Kojo Amponsah',    class: 'Grade 8B', balance: 0,      status: 'current', avatar: 'KA' },
]

export const MOCK_GRADES = [
  { subject: 'Mathematics',       class: 'Grade 8A', avg: 74, high: 96, low: 42, submitted: 28, total: 30 },
  { subject: 'English Language',  class: 'Grade 8A', avg: 81, high: 98, low: 55, submitted: 30, total: 30 },
  { subject: 'Integrated Science',class: 'Grade 8A', avg: 68, high: 91, low: 38, submitted: 27, total: 30 },
  { subject: 'Social Studies',    class: 'Grade 8A', avg: 79, high: 95, low: 50, submitted: 30, total: 30 },
  { subject: 'ICT',               class: 'Grade 8A', avg: 86, high: 100, low: 62, submitted: 29, total: 30 },
  { subject: 'French',            class: 'Grade 8A', avg: 71, high: 89, low: 44, submitted: 28, total: 30 },
]

export const MOCK_ATTENDANCE = [
  { date: '2026-04-28', day: 'Mon', present: 284, absent: 16, rate: 94.7 },
  { date: '2026-04-27', day: 'Tue', present: 291, absent: 9,  rate: 97.0 },
  { date: '2026-04-26', day: 'Wed', present: 276, absent: 24, rate: 92.0 },
  { date: '2026-04-25', day: 'Thu', present: 288, absent: 12, rate: 96.0 },
  { date: '2026-04-24', day: 'Fri', present: 270, absent: 30, rate: 90.0 },
]

export const MOCK_ACTIVITY = [
  { action: 'Payment recorded',         detail: 'GHS 450 for Abena Mensah',       time: '2 min ago',  type: 'payment' },
  { action: 'Attendance saved',         detail: 'Term 2, Week 8 - Grade 7A',      time: '1 hr ago',   type: 'attendance' },
  { action: 'New student enrolled',     detail: 'Kofi Boateng → Grade 7B',        time: '3 hrs ago',  type: 'student' },
  { action: 'SMS broadcast sent',       detail: '38 parents notified (Week 8)',    time: '5 hrs ago',  type: 'sms' },
  { action: 'Report card generated',    detail: 'Grade 8A - Term 2',              time: 'Yesterday',  type: 'academic' },
  { action: 'Fee plan updated',         detail: 'Transport fee → GHS 120/term',   time: 'Yesterday',  type: 'finance' },
]

export const PRICING_PLANS = [
  {
    name: 'Starter',
    price: 299,
    currency: 'GHS',
    period: 'month',
    tagline: 'For small schools',
    color: 'cyan',
    features: [
      'Up to 300 students',
      'Choose 3 modules',
      'SMS credits available',
      'Multiple staff users',
      'Email support',
      'Basic reports',
    ],
    missing: ['Activity logs', 'Parent portal', 'Custom branding'],
  },
  {
    name: 'Professional',
    price: 799,
    currency: 'GHS',
    period: 'month',
    tagline: 'For growing schools',
    color: 'indigo',
    recommended: true,
    features: [
      'Up to 1,500 students',
      'Choose 7 modules',
      'SMS credits available',
      'Multiple staff users',
      'Parent portal',
      'Priority support',
      'Activity logs',
      'Custom branding',
      'Advanced reports',
    ],
    missing: ['All modules included'],
  },
  {
    name: 'Enterprise',
    price: null,
    currency: 'GHS',
    period: 'month',
    tagline: 'For large institutions',
    color: 'slate',
    features: [
      'Unlimited students',
      'All 11 modules',
      'SMS credits available',
      'Unlimited staff users',
      'Parent portal',
      'Dedicated support',
      'Activity logs',
      'Custom branding',
      'Advanced reports',
      'Multi-campus support',
    ],
    missing: [],
  },
]

export const SMS_PACKS = [
  { qty: 100,  amount: 25,  label: 'GHS 25'  },
  { qty: 500,  amount: 110, label: 'GHS 110' },
  { qty: 1000, amount: 200, label: 'GHS 200' },
  { qty: 5000, amount: 900, label: 'GHS 900' },
]

export const TESTIMONIALS = [
  {
    quote: "MySchoolPortal made attendance and feeding much easier to manage. Work that used to take hours now takes minutes.",
    name: 'Mrs. Augustina',
    role: 'Head of Administration',
    school: 'Faith International School',
    avatar: 'AA',
  },
  {
    quote: "We can now send SMS to parents quickly, and payment tracking is much easier too.",
    name: 'Mr. Kwesi Appiah',
    role: 'Accountant',
    school: 'Greenfield Academy',
    avatar: 'KA',
  },
  {
    quote: "Attendance, grades, and student records are all in one place now, and every staff member only sees what they need to.",
    name: 'Dr. Ama Owusu',
    role: 'Headteacher',
    school: 'Sunshine Preparatory',
    avatar: 'AO',
  },
]
